export interface NewOrganizationPayload {
  organizationCode: string
  registrationFirstName: string
  registrationLastName: string
  registrationEmail: string
  registrationPassword: string
  deployType: InstallOptions
}

export enum ProvisioningStatus {
  PROVISIONING_NEW = 'PROVISIONING_NEW',
}

export interface NewOrganizationResponse {
  organization: {
    id: string
    code: string
    name: string
    licenseId: any
  }
  provisioning: {
    id: string
    organizationId: string
    status: ProvisioningStatus
    errorMessage: any
  }
}

export enum InstallOptions {
  ON_PREM = 'ONPREM',
  SAAS = 'SAAS',
}

export enum InstallStatus {
  OK = 'OK',
  MISSING_LICENSE = 'MISSING_LICENSE',
  MISSING_ORGANIZATION = 'MISSING_ORGANIZATION',
  CREATING_ORGANIZATION = 'CREATING_ORGANIZATION',
}

export interface EnvironmentDefinition {
  installation: InstallOptions
  envName: string
  status?: InstallStatus
  organizationInfo?: OrganizationPublicInfo
}

export interface OrganizationPublicInfo {
  organizationId: string
  issuer: string
  tokenEndpoint: string
  clientId: string
  redirectUri: string
  genericRuntimeUri: string
  orgCode?: string
}

export type NewOnPremOrganizationPayload = Pick<
  NewOrganizationPayload,
  'registrationFirstName' | 'registrationLastName' | 'registrationEmail' | 'registrationPassword'
> & { environmentName: string }
